@if (visible()) {
<div
  class="fnf-dialog-overlay fixed inset-0 bg-black/60 transition-opacity duration-300 ease-out opacity-100"
>
  <div
    [class]="dialogCardClass()"
    class="transition-all duration-300 ease-out transform opacity-100 scale-100"
  >
    <!-- Header -->
    <div
      class="fnf-dialog-header"
      [ngClass]="{
          'border-b border-[#d1d1d1]': subject() && subject().trim() !== '',
        }"
    >
      @if (subject() && subject().trim() !== '') {
      <p>{{ subject() }}</p>
      }
      <button (click)="close()" class="fnf-dialog-close-button" aria-label="Cerrar modal">X</button>
    </div>

    <!-- Content -->
    <div class="fnf-dialog-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
}
